/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchScansResponse } from './search-scans-response';


export interface SearchScansResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchScansResponse> | null;
}

